var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { sendAjaxRequest } from "../API";
import { create } from "zustand";
const LOGPREFIX = "ModeratedPostStore: ";
export const useModeratedPostStore = create((set, get) => ({
    moderatedPosts: undefined,
    loading: false,
    error: null,
    includeReviewed: false,
    setIncludeReviewed: (includeReviewed) => {
        set({ includeReviewed });
    },
    loadModeratedPosts: (auth, cacheBusterStore, logger, includeReviewed) => __awaiter(void 0, void 0, void 0, function* () {
        // cacheBusterStore is used in the real implementation but not in the simulation
        logger.log(LOGPREFIX + "loadModeratedPosts");
        set({ loading: true, error: null });
        const apiCallback = (ok, status, message) => {
            if (ok) {
                logger.log(LOGPREFIX + "loadModeratedPosts: apiCallback OK");
                const obj = JSON.parse(message);
                logger.log(LOGPREFIX +
                    "loadModeratedPosts: apiCallback OK - parsed output = " +
                    JSON.stringify(obj));
                if (obj.bearer && obj.sequence) {
                    logger.log(LOGPREFIX +
                        "loadModeratedPosts: apiCallback OK - bearer and sequence set");
                    auth.setBearerAndSequence(obj.bearer, obj.sequence, logger);
                }
                else {
                    console.error("loadModeratedPosts: apiCallback OK - missing bearer and sequence");
                    set({
                        loading: false,
                        error: "API response does NOT contain bearer and sequence",
                    });
                    return;
                }
                try {
                    const result = JSON.parse(message);
                    if (!result) {
                        throw new Error("loadModeratedPosts:Unable to decode moderated posts response.");
                    }
                    logger.log(LOGPREFIX +
                        "loadModeratedPosts: result.results = " +
                        JSON.stringify(result.results));
                    logger.log(LOGPREFIX +
                        "loadModeratedPosts: result.results.length = " +
                        (result.results ? result.results.length : "undefined"));
                    set({
                        loading: false,
                        moderatedPosts: result.results || [],
                        error: null,
                    });
                }
                catch (err) {
                    console.error("loadModeratedPosts: apiCallback ERROR = " + status + " " + message);
                    const errorMessage = err instanceof Error
                        ? err.message
                        : "Unable to load moderated posts.";
                    set({ loading: false, error: errorMessage });
                }
            }
            else {
                console.error("loadModeratedPosts: apiCallback ERROR = " + status + " " + message);
                set({ loading: false, error: message });
            }
        };
        // Use the provided parameter, or fall back to the store state
        const currentState = get();
        const shouldIncludeReviewed = includeReviewed !== undefined
            ? includeReviewed
            : currentState.includeReviewed;
        const path = "moderation";
        const input = {
            operation: "getAllPostModerationLabels",
            includeReviewed: shouldIncludeReviewed,
            sequence: auth.sequence,
        };
        logger.log(LOGPREFIX + "loadModeratedPosts: input " + JSON.stringify(input));
        logger.log(LOGPREFIX +
            "loadModeratedPosts: about to call sendAjaxRequest with path = " +
            path);
        sendAjaxRequest(apiCallback, path, input, auth.bearer, cacheBusterStore, logger);
    }),
}));
export const setModerationReviewStatus = (fileName, reviewStatus, auth, cacheBusterStore, okCallback, errorCallback, logger) => __awaiter(void 0, void 0, void 0, function* () {
    logger.log(LOGPREFIX + "setModerationReviewStatus for file: " + fileName);
    const apiCallback = (ok, status, message) => {
        if (ok) {
            logger.log(LOGPREFIX + "setModerationReviewStatus: apiCallback OK");
            const obj = JSON.parse(message);
            logger.log(LOGPREFIX +
                "setModerationReviewStatus: apiCallback OK - parsed output = " +
                JSON.stringify(obj));
            if (obj.bearer && obj.sequence) {
                logger.log(LOGPREFIX +
                    "setModerationReviewStatus: apiCallback OK - bearer and sequence set");
                auth.setBearerAndSequence(obj.bearer, obj.sequence, logger);
            }
            else {
                console.error("setModerationReviewStatus: apiCallback OK - missing bearer and sequence");
                errorCallback("API response does NOT contain bearer and sequence.");
                return;
            }
            okCallback();
        }
        else {
            console.error("setModerationReviewStatus: apiCallback ERROR = " +
                status +
                " " +
                message);
            errorCallback(message ? message : "Unknown error occurred.");
            return;
        }
    };
    const path = "moderation";
    const channelOwnerId = fileName.split("/")[1];
    const channelId = fileName.split("/")[2];
    const postId = fileName.split("/")[3].split("_")[0];
    const input = {
        operation: "setPostModerationReviewStatus",
        channelOwnerId,
        channelId,
        postId,
        reviewStatus,
        fileName,
        sequence: auth.sequence,
    };
    logger.log(LOGPREFIX + "setModerationReviewStatus: input " + JSON.stringify(input));
    sendAjaxRequest(apiCallback, path, input, auth.bearer, cacheBusterStore, logger);
});
